import React, {Fragment} from 'react';
import 'moment/locale/it';
import 'moment/locale/en-gb';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {Tab, Tabs} from 'react-bootstrap';
import CommonMetaTag from './common-meta-tag';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PartnerBookingsReport from './partner-bookings-report';
import PartnerReportTransaction from './partner-report-transaction';
import PartnerReportSubscriptions from './partner-report-subscriptions';
import PartnerReportPlayers from './partner-report-players';
import ShopReport from './shop-report';
import PartnerDedicatedFieldCostReport from './partner-dedicated-field-cost-report';
import PartnerReportBookingSeries from './partner-report-booking-series';

const PartnerReport = ({ownedRtvChannels}) => {
    const {t} = useTranslation();

    return(
        <Fragment>
            <CommonMetaTag/>
            <main className="partner-report-skywork-page">
              <div className="partner-report-skywork-shell">
                <header className="partner-report-skywork-hero">
                  <span className="partner-report-skywork-eyebrow">{t('REPORTS_AND_DATA')}</span>
                  <h1>{t('REPORT')}</h1>
                  <p>{t('PARTNER_REPORT_INTRO')}</p>
                </header>
                <Tabs defaultActiveKey="transactions" className="partner-report-skywork-tabs" mountOnEnter unmountOnExit>
                <Tab eventKey="transactions" title={<span><i className="fa fa-credit-card"/> {t('TRANSACTIONS')}</span>} tabClassName="partner-report-skywork-tab">
                    <PartnerReportTransaction/>
                </Tab>
                <Tab eventKey="bookings" title={<span><i className="fa fa-calendar"/> {t('BOOKINGS')}</span>} tabClassName="partner-report-skywork-tab">
                    <PartnerBookingsReport/>
                </Tab>
                <Tab eventKey="dedicated-field-cost" title={<span><i className="fa fa-users"/> {t('DEDICATED_FIELD_COST_REPORT_SHORT')}</span>} tabClassName="partner-report-skywork-tab">
                    <PartnerDedicatedFieldCostReport/>
                </Tab>
                <Tab eventKey="booking-series" title={<span><i className="fa fa-calendar-check-o"/> {t('BOOKING_SERIES_REPORT_SHORT')}</span>} tabClassName="partner-report-skywork-tab">
                    <PartnerReportBookingSeries/>
                </Tab>
                {ownedRtvChannels.length > 0 ?
                <Tab eventKey="subscriptions" title={<span><i className="fa fa-repeat"/> {t('RTV_SUBSCRIPTIONS')}</span>} tabClassName="partner-report-skywork-tab">
                    <PartnerReportSubscriptions/>
                </Tab>
                : null}
                <Tab eventKey="players" title={<span><i className="fa fa-users"/> {t('PLAYER')}</span>} tabClassName="partner-report-skywork-tab">
                    <PartnerReportPlayers/>
                </Tab>
                <Tab eventKey="shop" title={<span><i className="fa fa-shopping-bag"/> {t('SHOP')}</span>} tabClassName="partner-report-skywork-tab">
                    <ShopReport scope="partner"/>
                </Tab>
                </Tabs>
              </div>
            </main>
        </Fragment>
    );
};

const mapStateToProps = ({partner: {ownedRtvChannels}}) => ({
    ownedRtvChannels
  });

  export default withRouter(connect(
    mapStateToProps,
  )(PartnerReport));
